import { Flex } from '@chakra-ui/react';

import { CheckboxWithField } from 'components/Checkbox';
import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { Optional } from 'components/Text';
import SectionHeading from 'components/Text/SectionHeading';
import {
  FUNDRAISING,
  OTHER_FINANCING_SOLUTIONS,
  PAYMENT_TRANSACTIONS,
  PROFESSIONAL_EVENTS,
} from 'modules/Inquiry/Form/formFields';
import { FormSections } from 'schema/inquirySchema.models';
import { useTranslations } from 'utils/hooks/useTranslations';

interface FurtherNeedProps {
  sectionNumber: number;
}

// EBS-38: "Weiterer Bedarf" is an optional multi-select (no Yes/No gate). The selected
// options are collected into the `further-need-values` array on submit (see
// mapBFSProductDetailsToApi). Options are the four harmonized topics.
const FurtherNeed = ({ sectionNumber }: FurtherNeedProps) => {
  const t = useTranslations('pages.requestDetails.sections.furtherNeed');
  const tGlobal = useTranslations();

  return (
    <FormSection name={FormSections.furtherNeed} sectionNumber={sectionNumber} title={t('title')}>
      {/* EBS-38: the whole section is optional — flag it like other optional fields
          (e.g. "Gewünschter Termin für die Bereitstellung"). */}
      <Flex justifyContent="space-between" alignItems="flex-start">
        <SectionHeading>{t('fields.adviceTopics.caption')}</SectionHeading>
        <Optional>{tGlobal('other.optional')}</Optional>
      </Flex>
      <FormRow space="2px">
        <CheckboxWithField
          name={PAYMENT_TRANSACTIONS}
          text={<span>{t('fields.adviceTopics.paymentTransactions.label')}</span>}
        />
        <CheckboxWithField
          name={PROFESSIONAL_EVENTS}
          text={<span>{t('fields.adviceTopics.professionalEvents.label')}</span>}
        />
      </FormRow>
      <FormRow space="2px">
        <CheckboxWithField
          name={FUNDRAISING}
          text={<span>{t('fields.adviceTopics.fundraising.label')}</span>}
        />
        <CheckboxWithField
          name={OTHER_FINANCING_SOLUTIONS}
          text={<span>{t('fields.adviceTopics.otherFinancingSolutions.label')}</span>}
        />
      </FormRow>
    </FormSection>
  );
};

export default FurtherNeed;
